import {
  AUTO_FILL_UPGRADE_AMOUNT,
  AUTO_FILL_UPGRADE_PACKAGE_ID,
  CURRENT_ACTIVATION_FEE,
  isCurrentTierActivationFee,
  LEGACY_ACTIVATION_FEE,
  PREVIOUS_CURRENT_ACTIVATION_FEE,
} from "./membershipConfig";
import { isAutoFillUpgradeOrder } from "../utils/autoFillMembershipEnrollment";

/** ₹100 total — legacy ₹499 activation membership */
export const ROYALTY_AMOUNTS_LEGACY_ACTIVATION = {
  1: 50.0,
  2: 15.0,
  3: 10.0,
  4: 5.0,
  5: 5.0,
  6: 5.0,
  7: 2.5,
  8: 2.5,
  9: 2.5,
  10: 2.5,
};

/** ₹100 total — current-tier activation membership (₹699; legacy ₹649 orders use same table) */
export const ROYALTY_AMOUNTS_CURRENT_ACTIVATION = {
  1: 40.0,
  2: 15.0,
  3: 10.0,
  4: 5.0,
  5: 5.0,
  6: 5.0,
  7: 5.0,
  8: 5.0,
  9: 5.0,
  10: 5.0,
};

export function getRoyaltyAmountsForActivationFee(activationFee) {
  const fee = Number(activationFee);
  if (fee === LEGACY_ACTIVATION_FEE) {
    return ROYALTY_AMOUNTS_LEGACY_ACTIVATION;
  }
  if (isCurrentTierActivationFee(fee)) {
    return ROYALTY_AMOUNTS_CURRENT_ACTIVATION;
  }
  return null;
}

/** ₹150 legacy → AFP upgrade: royalty was paid on original ₹499 activation only. */
export function isAutoFillProgramUpgradePurchase({
  order = null,
  pkg = null,
  isAutoFillUpgrade = false,
  packageId = null,
  packageCategory = null,
  packagePrice = null,
} = {}) {
  if (isAutoFillUpgrade === true) return true;
  if (order && pkg && isAutoFillUpgradeOrder(order, pkg)) return true;
  const id = packageId ?? pkg?.id;
  if (id === AUTO_FILL_UPGRADE_PACKAGE_ID) return true;
  const category = packageCategory ?? pkg?.category;
  if (category === "Auto Fill Upgrade") return true;
  const price = Number(packagePrice ?? pkg?.price);
  if (price === AUTO_FILL_UPGRADE_AMOUNT) return true;
  return false;
}

/**
 * Activation fee for royalty (cart orders often store fee on pkg.activationFee,
 * checkout orders use pkg.subItemsData.activationFee).
 */
export function resolveActivationFeeForRoyalty(order, pkg) {
  if (!pkg && !order) return null;

  const candidates = [
    pkg?.subItemsData?.activationFee,
    order?.subItemsData?.activationFee,
    pkg?.activationFee,
    order?.activationFee,
    order?.purchasedActivationFee,
  ];

  for (const value of candidates) {
    if (value != null && value !== "") {
      const n = Number(value);
      if (!Number.isNaN(n)) return n;
    }
  }

  const isMembershipSubItem =
    pkg?.isSubItemPackage === true || order?.isSubItemPackage === true;
  if (isMembershipSubItem) {
    return CURRENT_ACTIVATION_FEE;
  }

  const price = Number(pkg?.price);
  if (
    !isAutoFillProgramUpgradePurchase({ order, pkg }) &&
    (price === LEGACY_ACTIVATION_FEE ||
      price === CURRENT_ACTIVATION_FEE ||
      price === PREVIOUS_CURRENT_ACTIVATION_FEE)
  ) {
    return price;
  }

  return null;
}

export function orderQualifiesForActivationRoyalty(order, pkg) {
  if (!pkg) return false;
  if (isAutoFillProgramUpgradePurchase({ order, pkg })) {
    return false;
  }
  const activationFee = resolveActivationFeeForRoyalty(order, pkg);
  return getRoyaltyAmountsForActivationFee(activationFee) != null;
}

export function purchaseDataQualifiesForActivationRoyalty(purchaseData) {
  if (!purchaseData) return false;
  if (
    isAutoFillProgramUpgradePurchase({
      isAutoFillUpgrade: purchaseData.isAutoFillUpgrade,
      packageId: purchaseData.packageId,
      packageCategory: purchaseData.packageCategory,
      packagePrice: purchaseData.packagePrice,
    })
  ) {
    return false;
  }
  return getRoyaltyAmountsForActivationFee(purchaseData.activationFee) != null;
}
